export const GET_PREPARED_CARDS_PLANNING = "GET_PREPARED_CARDS_PLANNING"
export const GET_PREPARED_CARDS_PLANNING_SUCCESS = "GET_PREPARED_CARDS_PLANNING_SUCCESS"
export const SET_PLANNING_IS_LOADING = "SET_PLANNING_IS_LOADING"
export const GET_OCCURRENCES = "GET_OCCURRENCES"
export const GET_OCCURRENCES_SUCCESS = "GET_OCCURRENCES_SUCCESS"
export const GET_ACTUAL_OCCURRENCE = "GET_ACTUAL_OCCURRENCE"
export const GET_ACTUAL_OCCURRENCE_SUCCESS = "GET_ACTUAL_OCCURRENCE_SUCCESS"
export const CLEAR_ACTUAL_OCCURRENCE = "CLEAR_ACTUAL_OCCURRENCE"
export const SELECT_PLANNING_VERSION = "SELECT_PLANNING_VERSION"
export const GET_OCCURRENCES_BY_DATES = "GET_OCCURRENCES_BY_DATES"
export const GET_OCCURRENCES_BY_DATES_SUCCESS = "GET_OCCURRENCES_BY_DATES_SUCCESS"
export const WAITING_SAVING = "WAITING_SAVING"
